<div class="MainContainer">

    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'TaxationReport' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
            <button (click)="ExportStockBalanceValues();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        </div>
    </div>

    <div class="overlay" *ngIf="ShowProductHistoryEventsContainer || ShowCashCollectionContainer || showEditPartnerPopUp || showInvoiceVisualizer;" (click)="showEditPartnerPopUp = false; showInvoiceVisualizer = false;"></div>

    <div class="ProductHistoryEventsContainer" *ngIf="ShowProductHistoryEventsContainer">
      <div class="PopUpCloseContainer" (click)="ShowProductHistoryEventsContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{ 'ProductEventHistory' | translate }}: [{{auxProduct.ProductCode}}] {{auxProduct.ProductName}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="ProductHistoryRow" *ngFor="let e of this.ProductEvents; let j=index;">
          <p style="color: #0082e6;">{{e.DisplayValue}} : {{e.EventRegisterUI}}</p>
          <p *ngIf="e.GeneralDocType != null;">{{'DocQuantity' | translate}}: {{e.AbsDocQuantity}}</p>
          <p *ngIf="e.GeneralDocType != null;">{{'DocumentType' | translate}}: <span style="color:#32aa3a;">{{e.GeneralDocType?.Name}}</span></p>
          <p *ngIf="e.Discrepancy > 0;">{{'Discrepancy' | translate}}: <span style="color: red;">{{e.Discrepancy}}</span> / {{'StockQuantity' | translate}}: <span style="color: red;">{{e.AbsStockQuantity}}</span></p>
          <p>{{'CurrentQuantity' | translate}}: <span [ngClass]="{'positiveQty': e.FinalQuantity > 0, 'negativeQty' : e.FinalQuantity < 0 }">{{e.FinalQuantity}}</span></p>
        </div>
      </div>
    </div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetTaxationReport();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetTaxationReport();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
      </div>

      <div class="MainTitleBar" style="overflow: unset;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                  <mat-radio-group
                  [(ngModel)]="Taxation">
                  <mat-radio-button class="example-radio-button TaxationButton" *ngFor="let t of this.Taxations" [value]="t">
                    {{t.Type.Name}}
                  </mat-radio-button>
                </mat-radio-group>
                </div>
    
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <mat-select name="Administration" [(ngModel)]="Filter.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (click)="AddActiveFilter(a.Name, 'Administration');">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}*</mat-label>
                        <input matInput placeholder="Product*" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                      </mat-form-field>
                </div>
              
              <div class="PopUpBodyTwoThirdsContainer">
                <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{ 'TaxationProductType' | translate }}</mat-label>
                  <mat-select name="TaxationProductType" [(ngModel)]="Filter.TaxationProductType">
                    <mat-option *ngFor="let t of this.TaxationProductTypes;" [value]="t" (click)="AddActiveFilter(t.Name, 'TaxationProductType');">
                      {{t.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="PopUpBodyOneThirddContainer">
                <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" *ngIf="Filter.TaxationProductType != null && Filter.TaxationProductType?.ID == 0;">
                    <mat-label>{{ 'ProductGeneralType' | translate }}</mat-label>
                    <mat-select name="ProductGeneralType" [(ngModel)]="Filter.ProductGeneralType">
                      <mat-option *ngFor="let t of this.ProductGeneralTypes;" [value]="t" (click)="AddActiveFilter(t.Name, 'ProductGeneralType');">
                        {{t.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>

            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{ 'DecimalPercision' | translate }}</mat-label>
                  <mat-select name="DecimalPrecision" [(ngModel)]="Filter.DecimalPrecision">
                    <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d" (click)="AddActiveFilter(d.Meaning, 'DecimalPrecision');">
                      {{d.Meaning}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
          </div>
              
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetTaxationReport();">{{ 'CalculateTaxation' | translate }}</button>
            </div>
        </div>
    </div>

    <div class="MainBody">

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
              
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 2%;">
                    {{ 'Entity' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 25%;text-align: left;padding-left: 2%;">
                  {{ 'Name' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 2%;">
                  {{ 'Code' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;text-align: left;padding-left: 2%;">
                  {{ 'Quantity' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 2%;">
                  {{ 'SellPrice' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 2%;">
                    {{ 'PurchasePrice' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 2%;">
                    {{ 'Profit' | translate }}
                  </div>
            </div>
    
            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>
            <div *ngIf="!loading">

              <div *ngFor="let partent of this.TaxationParents;">
                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow">
                  <div class="ReceptionProductsCol TotalCol" style="width: 10%;text-align: left;padding-left: 2%;">
                    <span *ngIf="partent.ContentType.ID != 0;">{{partent.ContentType.Name}}</span>
                    <span *ngIf="partent.ContentType.ID == 0;">{{partent.ContentType.ProductGeneralType.Name}}</span>
                  </div>
                  <div class="ReceptionProductsCol TotalCol" style="width: 25%;text-align: left;padding-left: 2%;">
                    <div class="TotalColIcon" *ngIf="!partent.ShowProducts">
                      <i class="material-icons" (click)="partent.ShowProducts = !partent.ShowProducts; partent.IsLoading = true;GetTaxationReportElements(partent.ContentType, partent.UIID);">lock_outline</i>
                    </div>
                    <div class="TotalColIcon" *ngIf="partent.ShowProducts">
                      <i class="material-icons" (click)="partent.ShowProducts = !partent.ShowProducts;">lock_open</i>
                    </div>
                    <mat-spinner class="smallSpinnerProductsRow" [diameter]="30" *ngIf="partent.IsLoading;"></mat-spinner>
                  </div>
                  <div class="ReceptionProductsCol TotalCol" style="width: 15%;padding-left: 2%;text-align: left;">
                    Total:
                  </div>
                  <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                    <span *ngIf="partent.Total.TotalSellPrice != 0;">
                      <p>{{partent.Total.UITotalSellPrice.Integer}} <span class="DecimalsSpan">{{partent.Total.UITotalSellPrice.Decimals}}</span></p>
                    </span>
                    </div>
                    <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                      <p>{{partent.Total.UITotalPurchasePrice.Integer}} <span class="DecimalsSpan">{{partent.Total.UITotalPurchasePrice.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol TotalCol" style="width: 20%;text-align: left;padding-left: 2%;">
                      <p>{{partent.Total.UITotalProfit.Integer}} <span class="DecimalsSpan">{{partent.Total.UITotalProfit.Decimals}}</span></p>
                    </div>
                </div>

                <div *ngIf="partent.ShowProducts">
                  <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let product of partent.TaxationProducts;" [ngClass]="{'TaxationProductError': product.Status?.ID == -1, 'TaxationProductComplete': product.Status?.ID == 1, 'TaxationProductStorno': product.StockRoot == 2 || product.StockRoot == 4}">
                    <div class="ReceptionProductsCol DottedRow" style="width: 10%;text-align: left;padding-left: 2%;">
                      {{product.Type.Name}} <span *ngIf="product.StockRoot == 2 || product.StockRoot == 4;">({{'Storno' | translate}})</span>
                    </div>
                    <div class="ReceptionProductsCol DottedRow" style="width: 25%;text-align: left;padding-left: 2%;" matTooltip="{{product.ProductName}}" [matTooltipClass]="{ 'tool-tip': true }">
                      {{product.ProductName}}
                    </div>
                    <div class="ReceptionProductsCol DottedRow" style="width: 10%;text-align: left;padding-left: 2%;">
                      {{product.ProductCode}}
                    </div>
                    <div class="ReceptionProductsCol DottedRow" style="width: 5%;padding-left: 2%;">
                      <span *ngIf="product.Quantity > 0;">{{product.Quantity}}</span>
                      <span *ngIf="product.Status?.ID == -1">/{{product.PurchasedQuantity}}</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 2%;">
                      <span *ngIf="product.TotalSellPrice != 0 || product.Type.ID == 0;">{{product.TotalSellPrice}}</span>
                      </div>
                      <div class="ReceptionProductsCol DottedRow" style="width: 15%;text-align: left;padding-left: 2%;">
                        {{product.TotalPurchasePrice}}
                      </div>
                      <div class="ReceptionProductsCol DottedRow" style="width: 10%;text-align: left;padding-left: 2%;">
                        <span>{{product.TotalProfit}}</span>
                      </div>
                      <div class="ReceptionProductsCol DottedRow" style="width: 10%;">
                        <i class="material-icons ReceptionProductEdit" (click)="GetProductHistoryEvents(product);" *ngIf="partent.ContentType.ID == 0 && product.StockRoot != 2 && product.StockRoot != 4;">format_list_numbered</i>
                      </div>
                </div>
                </div>
              </div>
           
           <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow">
            <div class="ReceptionProductsCol TotalCol" style="width: 10%;text-align: left;padding-left: 2%;">
              
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 25%;text-align: left;padding-left: 2%;">
             
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;padding-left: 2%;text-align: left;">
              Total:
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
              <p>{{Total.UITotalSellPrice.Integer}} <span class="DecimalsSpan">{{Total.UITotalSellPrice.Decimals}}</span></p>
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                <p>{{Total.UITotalPurchasePrice.Integer}} <span class="DecimalsSpan">{{Total.UITotalPurchasePrice.Decimals}}</span></p>
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 20%;text-align: left;padding-left: 2%;">
                <p>{{Total.UITotalProfit.Integer}} <span class="DecimalsSpan">{{Total.UITotalProfit.Decimals}}</span></p>
              </div>
          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow">
            <div class="ReceptionProductsCol TotalCol" style="width: 10%;text-align: left;padding-left: 2%;">
              
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 25%;text-align: left;padding-left: 2%;">
             
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;padding-left: 2%;text-align: left;">
              {{TotalTax.Title}}:
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
              
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 20%;text-align: left;padding-left: 2%;">
                <div *ngIf="TotalTax.Tax > 0;">
                  <p>{{TotalTax.UITax.Integer}} <span class="DecimalsSpan">{{TotalTax.UITax.Decimals}}</span></p>
                </div>
                <div *ngIf="TotalTax.Tax <= 0;">
                  <p>0 <span class="DecimalsSpan">.00</span></p>
                </div>
              </div>
          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="TotalTax.Tax <= 0;">
            <div class="ReceptionProductsCol TotalCol" style="width: 10%;text-align: left;padding-left: 2%;">
              
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 25%;text-align: left;padding-left: 2%;">
             
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;padding-left: 2%;text-align: left;">
              {{'TotalLoss' | translate}}:
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
              
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 20%;text-align: left;padding-left: 2%;">
                <p>{{Total.UITotalProfit.Integer}} <span class="DecimalsSpan">{{Total.UITotalProfit.Decimals}}</span></p>
              </div>
          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="TotalTax.Tax > 0;">
            <div class="ReceptionProductsCol TotalCol" style="width: 10%;text-align: left;padding-left: 2%;">
              
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 25%;text-align: left;padding-left: 2%;">
             
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;padding-left: 2%;text-align: left;">
              {{TotalAfterTax.Title}}:
            </div>
            <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
              
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 15%;text-align: left;padding-left: 2%;">
                
              </div>
              <div class="ReceptionProductsCol TotalCol" style="width: 20%;text-align: left;padding-left: 2%;">
                <p>{{TotalAfterTax.UITax.Integer}} <span class="DecimalsSpan">{{TotalAfterTax.UITax.Decimals}}</span></p>
              </div>
          </div>

            </div>
        </div>
    
    </div>

</div>
